import { useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import axios from "axios";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useToast } from "../../contexts/ToastContext";

const ModalQuartoEdit = ({ quarto, republica, fetchQuartos, fetchReps }) => {

    const { closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();

    const [loading, setLoading] = useState(false);

    const [quartoNome, setQuartoNome] = useState("" || (quarto && quarto.quarto_name));
    const [quartoVagas, setQuartoVagas] = useState("" || (quarto && quarto.vagas));

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        let url;

        if (quarto) {
            url = `https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/UpdateQuarto/index.php?id=${quarto.identifier}`;
        } else {
            url = `https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/AddQuarto/index.php`;
        }

        try {

            const formData = new FormData();
            formData.append('quarto_name', quartoNome);
            formData.append('vagas', quartoVagas);
            formData.append('id_republica', republica);
            if (quarto) {
                formData.append('id', quarto.identifier);
            }

            const { data } = await axios.post(url, formData, { withCredentials: true });
            console.log(data);

            await fetchQuartos();
            await fetchReps();

            let message = quarto ? "Quarto editado com sucesso." : "Quarto adicionado com sucesso."
            notifySuccess( message );

            closeModal();

        }catch(e){

            console.error(e);
            let message = quarto ? "Ocorreu um erro ao tentar editar o quarto." : "Ocorreu um erro ao tentar adicionar um quarto."
            notifyError( message );

        }finally{

            setLoading(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="md" header={true} close={closeModal} >
                    <Formulario onSubmit={ handleSubmit } >
                        <FormComp
                            title="NOME DO QUARTO"
                            type="text"
                            placeholder="Ex: Quarto 01"
                            valor={quartoNome}
                            changeFunc={(e) => setQuartoNome(e.target.value.toUpperCase())}
                        />
                        <FormComp
                            title="VAGAS"
                            type="number"
                            placeholder="Ex: 4"
                            valor={quartoVagas}
                            changeFunc={(e) => setQuartoVagas(e.target.value)}
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
                {loading && (
                    <Overlay state={ true } >
                        <Modal size="sm" header={ false } >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )}
            </Overlay>
        </>
    )
}

export default ModalQuartoEdit;